import { useSelector } from "react-redux";
import { routeConstant } from "shared/routes/routeConstant";
import ProjectsList from "shared/components/dashboardCommon/projectsList";

const BuilderArchivedProjects = () => {
  const auth = useSelector((state: any) => state.root.auth);

  return (
    <ProjectsList
      userType="builder"
      pageTitle={`${auth?.user?.display_name || "Your"} Archived Projects`}
      pageDescription="Archived projects remain available here for up to 6 months."
      showSearchFilter={true}
      EnableApiIntegration={true}
      noContentMessage="No archived projects yet."
      detailRoutePath={routeConstant.builder.projectDetail.path}
      isArchived={true}
      showArchiveButton={false}
    />
  );
};

export default BuilderArchivedProjects;
